// extracted by mini-css-extract-plugin
module.exports = {"courseCardList":"CourseCardList_courseCardList__1Pa2h","courseCard":"CourseCardList_courseCard__3LPkX"};